<div class="offering-page">
  <div class="breadcrumbs">
    @if (breadcrumbs().length > 0) {
      <inexp-breadcrumbs [items]="breadcrumbs()"></inexp-breadcrumbs>
    }
  </div>

  @if (isLoading()) {
    <inexp-offering-skeleton />
  } @else {
  <div class="content">
    <div class="sidebar bg-blue-gradient-top-right">
      <div class="main-content">
        <p class="ui-label-l-bold main-content-title">Main content</p>
        @for (section of sections; track $index) {
          <a
            class="menu-item"
            [class.active]="activeSection() === section"
            (click)="scrollTo(section)"
          >
            {{ section }}
          </a>
        }
      </div>
      @if (knowledgeSections.length > 0) {
        <div class="knowledge-content">
          <p class="ui-label-l-bold knowledge-content-title">
            Knowledge content
          </p>
          @for (knowledgeSection of knowledgeSections; track $index) {
            <a
              class="menu-item"
              [class.active]="activeSection() === knowledgeSection"
              (click)="scrollTo(knowledgeSection)"
            >
              {{ knowledgeSection }}
            </a>
          }
        </div>
      }

      @if (extraSections.length > 0) {
        <div class="extra-content">
          @for (extraSection of extraSections; track $index) {
            <a
              class="menu-item"
              [class.active]="activeSection() === extraSection"
              (click)="scrollTo(extraSection)"
            >
              {{ extraSection }}
            </a>
          }
        </div>
      }
    </div>

    <div class="offering">
      <!-- Replaces the catalog search field that used to head this page: on an
           offering, a question about *this* offering is more use than a search
           box that navigates away. It sits in the content column, above the
           hero, rather than spanning the sidebar too. The prompt fills in once
           the offering resolves, so the summary starts on arrival; follow-ups
           carry the offering name into the chat, since they will almost always
           be about it. -->
      <inexp-assistant-widget
        *inexpFeatureFlag="'panorama_inexp_2498_assistant'"
        [summaryPrompt]="assistantSummaryPrompt()"
        [followUpContext]="assistantContext()"
        [openingQuestion]="assistantOpeningQuestion()"
        followUpPlaceholder="Ask a follow-up about this offering..."
      />

      @if (components) {
        @for (c of componentsArray; track c._uid) {
          <section
            [attr.id]="c.section || c.knowledgeSection || c.extraSection"
            class="offering-section"
          >
            <ndc-dynamic
              [ndcDynamicComponent]="components[c.component]"
              [ndcDynamicInputs]="c"
            >
            </ndc-dynamic>
          </section>
        }
      }
    </div>
  </div>
  }
</div>
